// The "Your journey" feature checklist — the things a visitor can try. Tried-state is a single source
// of truth: the `triedFeatures` set in settings (Dexie-backed). Route-reachable features are marked in
// VisitTracker as the visitor navigates; in-place actions call markFeatureTried at their trigger.

export interface Feature {
  id: string;
  label: string;
  tip: string;
}

export const FEATURES: Feature[] = [
  { id: "open-experience", label: "Open an experience", tip: "Click any company card to see the role, the narrative, and the work behind it." },
  { id: "open-engagement", label: "Open an engagement", tip: "Open a project to read its story, the tech used, and the outcomes." },
  { id: "lens", label: "Filter by a lens", tip: "Use the Lens menu — Industry, Technology, Skill, Role — to slice the career your way." },
  { id: "graph", label: "Explore the graph", tip: "Switch the career view to Graph to see how experiences, tech, and skills connect." },
  { id: "ask-ai", label: "Ask the AI", tip: "Ask a question about my work — answers are grounded in this résumé." },
  { id: "talk-to-me", label: "Talk to me live", tip: "Start a live chat about a specific piece of work (powered by Amazon Connect)." },
  { id: "byo-ai", label: "Bring your own AI", tip: "Copy a ready-made, grounded prompt to drop into your own AI tool." },
  { id: "bookmark", label: "Bookmark something", tip: "Star an experience or engagement to pin it here in Your journey." },
  { id: "theme", label: "Switch day / night", tip: "Toggle the sun/moon in the top bar to flip between light and dark." },
  { id: "print", label: "Print / save a PDF", tip: "Open Print for a clean, one-page PDF version of the résumé." },
  { id: "about", label: "Read the case study", tip: "About → This app: how this site was designed and built with AI." },
  { id: "feedback", label: "Send feedback", tip: "Spotted a rough edge or have a thought? Send feedback or report a bug." },
];
